/**
 * Path for same-origin `<a href>` links (respects `REACT_APP_BASENAME` when set).
 * @param {string} path - e.g. "/privacy-policy"
 */
export function appPath(path) {
  const base = (process.env.REACT_APP_BASENAME || "").replace(/\/$/, "");
  const p = path.startsWith("/") ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}
